import { UnionMap, UnionValueMap } from '../types/union-map';

export type McpSupportSectionType = 'LocalMcpPackage' | 'VscodeInstallation';

export const McpSupportSectionType: UnionMap<McpSupportSectionType> = {
    LocalMcpPackage: 'LocalMcpPackage',
    VscodeInstallation: 'VscodeInstallation',
};

// Note: If these links need to be updated, update them directly or through aka.ms redirects
export const LocalMcpPackageLink = 'https://www.npmjs.com/package/@microsoft/devbox-mcp';
export const VscodeInstallationLink =
    'https://insiders.vscode.dev/redirect/mcp/install?name=DevBox&config=%7B%22command%22%3A%22npx%22%2C%22args%22%3A%5B%22-y%22%2C%22%40microsoft%2Fdevbox-mcp%40latest%22%5D%7D';

export const McpSupportSectionLinks: UnionValueMap<McpSupportSectionType, string> = {
    LocalMcpPackage: LocalMcpPackageLink,
    VscodeInstallation: VscodeInstallationLink,
};
